import './App.scss'

import Map from 'components/Map'
import { MetaDataStatus } from 'data/model/app'
import { RootState } from 'data/reducer'
import { fetchLocalizationData } from 'data/reducer/app'
import { useAppDispatch, useAppSelector } from 'data/store/hooks'
import { config } from 'lib/config'
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ReactComponent as ManeuverIconSprite } from 'sprites/maneuver-icons.svg'

import { Notifications } from '../Notifications'
import { SmallScreenOverlay } from '../SmallScreenOverlay'
import ThemeProvider, { Theme } from './components/ThemeProvider'

const PoiMarkersSprite = React.lazy(async () => {
  return { default: (await import(`sprites/poi-markers.svg`)).ReactComponent }
})

const IconsSprite = React.lazy(async () => {
  return { default: (await import(`sprites/icons.svg`)).ReactComponent }
})

export default function App(): JSX.Element | null {
  const dispatch = useAppDispatch()
  const userCountryCode = useAppSelector((state: RootState) => state.user.countryCode)
  const appStatus = useAppSelector((state: RootState) => state.app.status)
  const isMobileDevice = useAppSelector((state: RootState) => state.app.isMobileDevice)

  useEffect(() => {
    dispatch(fetchLocalizationData())
  }, [dispatch])

  return userCountryCode !== null ? (
    <ThemeProvider theme={Theme.light}>
      <main className="App">
        {isMobileDevice && <SmallScreenOverlay />}
        <Suspense fallback={null}>
          <PoiMarkersSprite style={{ display: 'none' }} />
          <IconsSprite style={{ display: 'none' }} />
        </Suspense>
        <ManeuverIconSprite style={{ display: 'none' }} />
        {!isMobileDevice && (
          <>
            <Notifications />
            <Router basename={config.ROOT_PATH}>
              {appStatus === MetaDataStatus.success && <Map />}
            </Router>
          </>
        )}
      </main>
    </ThemeProvider>
  ) : null
}
